"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountApi = exports.AccountApiFactory = exports.AccountApiFp = exports.AccountApiAxiosParamCreator = void 0;
const globalImportUrl = __importStar(require("url"));
const axios_1 = __importDefault(require("axios"));
const base_1 = require("../base");
const AccountApiAxiosParamCreator = function (configuration) {
    return {
        adminAccountV1AddUserPost: async (addUserDTO, options = {}) => {
            if (addUserDTO === null || addUserDTO === undefined) {
                throw new base_1.RequiredError('addUserDTO', 'Required parameter addUserDTO was null or undefined when calling adminAccountV1AddUserPost.');
            }
            const localVarPath = `/admin/account/v1/add-user`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof addUserDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(addUserDTO !== undefined ? addUserDTO : {}) : (addUserDTO || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AccountApiAxiosParamCreator = AccountApiAxiosParamCreator;
const AccountApiFp = function (configuration) {
    return {
        async adminAccountV1AddUserPost(addUserDTO, options) {
            const localVarAxiosArgs = await exports.AccountApiAxiosParamCreator(configuration).adminAccountV1AddUserPost(addUserDTO, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
exports.AccountApiFp = AccountApiFp;
const AccountApiFactory = function (configuration, basePath, axios) {
    return {
        adminAccountV1AddUserPost(addUserDTO, options) {
            return exports.AccountApiFp(configuration).adminAccountV1AddUserPost(addUserDTO, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AccountApiFactory = AccountApiFactory;
class AccountApi extends base_1.BaseAPI {
    adminAccountV1AddUserPost(addUserDTO, options) {
        return exports.AccountApiFp(this.configuration).adminAccountV1AddUserPost(addUserDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AccountApi = AccountApi;
//# sourceMappingURL=account-api.js.map